var path = 'src/app/patients/pkd/liver-diseases.html';
var html = "<h1 class=page-header>Liver Disease Manifestations</h1> <div liver-diseases-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/pkd/liver-diseases.html
 ** module id = 512
 ** module chunks = 0
 **/